<template>
	<div class="recruit">
		<div class="header">
			<div class="container">
				<div class="flex">
					<a class="logo"><img src="../../image/zsdb_logo.png" class="logoImg" style="width:132px"></a>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li>
							<li class="menulist"><a @click="gotoAboutus()" class="on">关于我们</a></li>
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../../image/ewm.jpg" class="code">
						<img src="../../image/icoewm.png" slot="reference" class="ico">
					</el-popover>
				</div>
			</div>
		</div>
		<div class="pagesbanner"
			style="background: url(//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_bannergy.jpg) top center no-repeat;">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh01.png"
				class="dh wow  fadeInLeft" style="left: 0">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh02.png"
				class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>关于我们</h3>
				<p>ABOUT US</p>
			</div>
		</div>
		<div class="pagesabout">
			<div class="container">
				<div class="flex">
					<div class="aboutleft">
						<div class="item">
							<a @click="gotoAboutus()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1on.png"
										class="icoon"></span>
								公司介绍
							</a>
						</div>
						<div class="item">
							<a @click="gotoProject()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2on.png"
										class="icoon"></span>
								典型工程
							</a>
						</div>
						<div class="item">
							<a @click="gotoCulture()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3on.png"
										class="icoon"></span>
								人才培养
							</a>
						</div>
						<div class="item">
							<a @click="gotoLife()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4on.png"
										class="icoon"></span>
								园区生活
							</a>
						</div>
						<div class="item on">
							<a @click="gotoRecruit()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5on.png"
										class="icoon"></span>
								招聘Q&A
							</a>
						</div>

					</div>
					<div class="aboutright">
						<div class="abouttitle">
							<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dd.png"
								class="ico">招聘Q&A
						</div>
						<div class="qalist">
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									招聘对象？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										2023届本科、硕士、博士毕业生（2022年9月至2023年8月期间毕业）。中国大陆地区以毕业证为准，非中国大陆地区以教育部学历认证报告为准，且最高学历毕业后无全职工作经验。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									每位同学最多可投几个职位？每人有几次机会？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										请进入各单位招聘页面投递，每位同学仅可投递一个职位，请谨慎选择。未被第一志愿录用不要灰心，简历仍有机会被其他单位处理。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									招聘的流程是怎么样的？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										招聘流程可参考以上流程。视疫情防控要求，部分院校的宣讲会和面试将在线上进行。<br>
										<img
											src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_liuchegntu.png">
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									如何投递简历？简历投递的时间范围是什么？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										登录华东院招聘官网hdec.zhiye.com投递简历，或在手机端进入华东院招聘微信公众号（中国电建华东院HDEC招聘平台）投递。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									忘记系统登录密码该怎么处理？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										请在系统登录界面点击“找回密码”，系统会发送临时密码至您的手机，用临时密码登录账号后，再在个人中心-账户设置处修改密码。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									注册简历投递系统后，邮箱/手机号码是否可以再修改？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										邮箱和手机号都可以修改。为保持联络畅通，建议使用长期有效的手机号码和常用邮箱。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									职位投递成功后，还可以修改投递信息吗？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										可以。在HR进行简历筛选前，候选人可以修改职位申请和个人简历信息。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									填写简历时无法选择/没有看到自己的毕业院校，该如何处理？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										可在院校列表下方点击“手动添加”并输入您的院校完整名称，或在“我的简历”中手动直接添加相应教育背景信息。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									填写简历时需要上传哪些材料？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										个人版简历、成绩单、英语四六级证书为必传项，毕业证、学位证、奖状、聘书等为非必传项，请根据简历分别上传佐证材料。简历要求为5M以内的doc、docx、pdf文件，其他附件要求为10M以内的jpg、png、jpeg、gif、bmp、doc、docx、xls、xlsx、pdf文件。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									我已完成一面，什么时候能收到面试结果？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										面试结果以各二级单位通知为准，请耐心等待。联系方式详见招聘主页。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									面试主要形式？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										“结构化面试+专业知识面试为主+语言能力考查”相结合，部分专业会安排笔试。面试在考察学生的专业能力以外，同样看重学生的综合素养。
									</div>
								</div>
							</div>
							<div class="item">
								<div class="q">
									<div class="ico">Q</div>
									看到华东院的行程中没有我们学校，是不是不招我们学校的？
								</div>
								<div class="a">
									<div class="ico">A</div>
									<div class="text">
										华东院的招聘是面向全球/全国高校的，因为涉及高校较多，基于往年的合作和我们招聘需求分布，而把宣讲会、一面定在一些城市的特定高校，只要你的专业符合我们的需求，就可以来投递简历、参加宣讲活动。
									</div>
								</div>
							</div>


						</div>

					</div>
				</div>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import backtop from "../../components/backtop.vue"
	import {
		loginstatus,
		Logout,
	} from '../../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			backtop,
		},
		data() {
			return {
				value1: '',
				islogin: false,
				unlogin: false,
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			})
		},

		methods: {
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			gotoIntern() {
				this.$router.push('/intern')
			},
			gotoProject() {
				this.$router.push('/aboutus/project')
			},
			gotoCulture() {
				this.$router.push('/aboutus/culture')
			},
			gotoLife() {
				this.$router.push('/aboutus/life')
			},
			// gotoRecruit() {
			// 	this.$router.push('/aboutus/recruit')
			// },
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../../assets/css/index.css);
</style>
